import DsTable from './DsTable'

export default Vue => {
  Vue.component(DsTable.name, DsTable)
}



// WEBPACK FOOTER //
// ./src/components/dstable/index.js